import React, { useContext, useEffect } from 'react';
import Cookies from 'universal-cookie';
import { Route, HashRouter } from 'react-router-dom';
import { hashHistory } from 'react-router';
import Store from './contexts/provider/Store';
import Routes from './routes/Routes';
import { LoginContext } from './contexts/constant/ActionTypes';
// css
import './App.scss';

const cookies = new Cookies();
const cookiesData = cookies.getAll();

const AppRoutes = ({ match, history }) => {

	const { auth, loginDetails } = cookiesData;
	const loginContext = useContext(LoginContext);

	useEffect(() => {
		if (auth) {
			loginContext.updateAuth(auth);
			loginContext.updateLoginDetails(loginDetails);
		}
	}, []);
	return (
		<Routes match={match} history={history} />
	);
}

const App = () => (
	<Store>
		<HashRouter history={hashHistory}>
			<Route path="/" component={AppRoutes} />
		</HashRouter>
	</Store>
);

export default App;



// WEBPACK FOOTER //
// ./App.js